// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"64e1c8d1","488":"49daee01"}[chunkId] + ".chunk.js";
};